import * as React from "react";
import { useEffect, useState } from "react";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { Urls } from "../../../../../../Urls";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { ProductOverviewCrystallisationAction } from "../Action/ProductOverviewCrystallisationAction";
import { Table } from "../../../../../../../Shared/Table/Table";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { Pager } from "../../../../../../../../react-core/Html/Pager";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionProtection } from "../../../../ClientRecord/PensionProtection";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import {
    DisinvestmentStrategyMap,
    DrawdownTypeOptionsMap,
    FrequencyMap,
} from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { DateHelper } from "../../../../../../../../react-core/Helpers/DateHelper";
import { DateRange } from "../../../../../../../Shared/Components/DateRange";
import { DateOptions } from "../../../../../../../Shared/Components/Resource/Contents";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { WizardLinkRestriction } from "../../../../Common/Restrictions/WizardLinkRestriction";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { SubAccountWizardLinkRestriction } from "../../../../Common/Restrictions/SubAccountWizardLinkRestriction";
import { RestrictionReasonStore } from "../../../../PortfolioDashboard/Store/Variables";
import { RestrictionReason } from "../../../../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionSubAccountSettings } from "../../../../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { PensionSubAccountSettingsStore } from "../../../../../../Stroes/Variable";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { useSubscribeToStore } from "../../../../../../../../react-core/Flux/Hooks/useSubscribeToStore";


interface IProductOverviewCrystallisationProps {
    headaccount: ClientAccount;
    subAccountHierarchyId: string;
    subClAccountId: string;
    customerHierarchyId: string;
    accountHierarchyId: string;
    subAccountType: SubAccountType;
}


export const ProductOverviewCrystallisation = (props: IProductOverviewCrystallisationProps) => {
    const formatPensionProtection = (hasPensionProtection) => (hasPensionProtection ? "Protection exists" : "No Protection");

    //state management
    const [lifetimeAllowanceData, setlifetimeAllowanceData] = useState(null);
    const [accountLifetimeAllowanceData, setAccountLifetimeAllowanceData] = useState(null);
    const [regularCrystallisationData, setregularCrystallisationData] = useState(null);
    const [historicCrystallisationData, setHistoricCrystallisationData] = useState(null);
    const [showEditLightbox, setShowEditLightbox] = useState(false);
    const [showRestrictionLightbox, setShowRestrictionLightbox] = useState(false);
    const [restrictionLightboxErrorMessage, setRestrictionLightboxErrorMessage] = useState(null);
    const [hasPensionProtection, setHasPensionProtection] = useState(false);
    const [filteredHistoricCrystallisationData, setFilteredHistoricCrystallisationData] = useState(historicCrystallisationData);
    const [isPensionSubAccountSettingsLoading, setIsPensionSubAccountSettingsLoading] = useState<boolean>(false);
    const [pensionSubAccountSettings, setPensionSubAccountSettings] = useState<PensionSubAccountSettings>(PensionSubAccountSettingsStore.getPensionSubAccountSettings());

    const [fromDate, setFromDate] = useState(JsonDateParser.toDate(props.headaccount.InceptionDate));
    const [toDate, setToDate] = useState(new Date());
    const [dateSelected, setDateSelected] = useState("Since account opening");

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    useSubscribeToStore(PensionSubAccountSettingsStore, () => {
        const data = PensionSubAccountSettingsStore.getPensionSubAccountSettings();
        setPensionSubAccountSettings(data);
        setIsPensionSubAccountSettingsLoading(PensionSubAccountSettingsStore.isLoading());
    });

    //LSA
    const totalOnPlatformLSAUsed = accountLifetimeAllowanceData?.UsedOnPlatformLumpSumAllowancePre2024 +
        accountLifetimeAllowanceData?.UsedOnPlatformLumpSumAllowancePost2024;

    const totalOffPlatformLSAUsed = accountLifetimeAllowanceData?.UsedOffPlatformLumpSumAllowancePre2024 +
        accountLifetimeAllowanceData?.UsedOffPlatformLumpSumAllowancePost2024;

    const totalLSAUsed = totalOnPlatformLSAUsed + totalOffPlatformLSAUsed;

    //LSDBA
    const totalOnPlatformLSDBAUsed = accountLifetimeAllowanceData?.UsedOnPlatformLumpSumDeathBenefitsAllowancePre2024 +
        accountLifetimeAllowanceData?.UsedOnPlatformLumpSumDeathBenefitsAllowancePost2024;

    const totalOffPlatformLSDBAUsed = accountLifetimeAllowanceData?.UsedOffPlatformLumpSumDeathBenefitsAllowancePre2024 +
        accountLifetimeAllowanceData?.UsedOffPlatformLumpSumDeathBenefitsAllowancePost2024;

    const totalLSDBAUsed = totalOnPlatformLSDBAUsed + totalOffPlatformLSDBAUsed;

    const addEvent = new AdviserSiteTagManager().addEvent;

    const isDpcNprAccount = (): boolean => {
        return pensionSubAccountSettings?.HasDisqualifyingPensionCredit ?? false;
    }

    //effects
    useEffect(() => {
        ProductOverviewCrystallisationAction.getRegularCrystallisationDetails(props.subAccountHierarchyId, (data) => {
            setregularCrystallisationData(data);
            setTotalRows(data?.length ?? 0);
        });

        ProductOverviewCrystallisationAction.getLifetimeAllowanceDetails(props.subAccountHierarchyId, (data) => {
            setlifetimeAllowanceData(data);
            setHasPensionProtection(!CommonHelper.isNullOrEmpty(data.PensionProtectionDetails));
        });

        ProductOverviewCrystallisationAction.getAccountLifetimeAllowanceDetails(props.accountHierarchyId, (data) => {
            setAccountLifetimeAllowanceData(data);
        });
    }, []);

    useEffect(() => {
        ProductOverviewCrystallisationAction.getHistoricCrystallisationDetails(
            props.subAccountHierarchyId,
            currentPage,
            pageSize,
            (data) => {
                setHistoricCrystallisationData(data?.Crystallisations);
                setTotalRows(data?.TotalRows);
                filteredHistoricCrystallisationDataByDateRange(data?.Crystallisations, JsonDateParser.toDate(props.headaccount.InceptionDate ?? data?.Crystallisations[0].PaymentDate ?? new Date()), new Date())
            }
        );
    }, [currentPage, pageSize]);

    useEffect(() => {
        if (props.subAccountType === SubAccountType.Npr || props.subAccountType === SubAccountType.JuniorSipp) {
            ProductOverviewCrystallisationAction.loadPensionSubAccountSettings(props.subAccountHierarchyId);
        }
    }, [props.subAccountHierarchyId]);

    function getCustomerId() {
        return HierarchyIdHelper.generateHierarchyId(props.customerHierarchyId).entityId?.toString();
    }

    function filteredHistoricCrystallisationDataByDateRange(historicCrystallisationData, from, to) {
        const result = historicCrystallisationData.filter((crystallisation) => {
            const crystallisationDate = JsonDateParser.toDate(crystallisation.PaymentDate);
            return (!from || crystallisationDate >= from) && (!to || crystallisationDate <= to);
        });
        setFilteredHistoricCrystallisationData(result);
    }

    function checkPaymentDateDifference() {
        if (regularCrystallisationData?.length > 0) {
            const currentDate = new Date();
            const result = regularCrystallisationData.filter((crystallisation) => {
                const paymentDate = JsonDateParser.toDate(crystallisation.PaymentDate);
                return DateHelper.getDayDifference(paymentDate, currentDate) >= 4;
            });
            return result.length > 0;
        }
        return false;
    }

    function isPensionProcessRestriction (restrictedReasons: RestrictionReason[]) 
    {
            let isPensionProcessRestriction : Boolean = false;
            if(restrictedReasons && restrictedReasons?.length > 0){
                restrictedReasons.map( x => 
                    {
                        if(x.ReasonName == "Pension Processing"){
                            isPensionProcessRestriction = true;
                            return;   
                        }
                    });
            }
            return isPensionProcessRestriction;
    };

    function getEditRegularDrawdownHref() {
        if (isDpcNprAccount()) {
            return "javascript:void(0);";
        }
        if (regularCrystallisationData?.length > 0) {
            return "/wpadviser/en-gb/dashboard/home/main/client/edit-income-drawdown/drawdown-detail?type=20&claccountid=" +
                props.headaccount.HeadClAccountId +
                "&subaccounthierarchyid=" +
                props.subAccountHierarchyId +
                "&customerid=" +
                getCustomerId() +
                "&hierarchyid=" +
                props.headaccount.HierarchyId
        }
        else {
            return "/wpadviser/en-gb/dashboard/home/main/client/pension-benefits/pension-benefits-details?type=20&claccountid=" +
                props.subClAccountId +
                "&hierarchyid=" +
                props.headaccount.HierarchyId +
                "&subaccounthierarchyid=" +
                props.subAccountHierarchyId
        }
    }

    if (isPensionSubAccountSettingsLoading) {
        return (
            <PartLoading isLoading={true}>
                <div className="table-skeleton"></div>
            </PartLoading>
        )
    }

    //tsx
    return (
        <>
            {showRestrictionLightbox && (
                <Lightbox
                    show={showRestrictionLightbox}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => setShowRestrictionLightbox(false)}
                    type={LightboxType.Modal}
                    unclosable={true}
                    noOverlay={false}
                    noAutofocus={true}
                    cssWrapper="is-default-lightbox is-narrow"
                >
                    <p>{restrictionLightboxErrorMessage}</p>

                    <button
                        className="btn primary"
                        onClick={() => setShowRestrictionLightbox(false)}
                    >
                        OK
                    </button>
                </Lightbox>
            )}
            <div className="ad d1">
                <div className="d-flex f-direction-column">
                    <div className="row mb-5">
                        <div className="col-fluid col-middle">
                            <h1 className="sr-only">Drawdown</h1>
                            <h2 className="mb-22">Allowance details</h2>
                        </div>
                    </div>
                    <div className="d-flex f-direction-column">
                        <div className="panel-subtle pt-20 pb-10 mb-40">
                            <div className="row wide-gutter">
                                <div className="col-12 col-sm-fluid col-equalise pt-20">
                                    <div
                                        className="panel-subtle pt-10 pb-10 mb-20 mr-25 ml-25"
                                        style={{ backgroundColor: "var(--panel-highlight)" }}
                                    >
                                        <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                            <tbody>
                                                <tr>
                                                    <th>LSA Used</th>
                                                    <td className="cell-right">
                                                        <div style={{ fontSize: "24px" }}>
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalLSAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}
                                                        </div>
                                                        <div>
                                                            (
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalOnPlatformLSAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}{" "}
                                                            on platform,&nbsp;
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalOffPlatformLSAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}{" "}
                                                            off platform)
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>LSDBA Used</th>
                                                    <td className="cell-right">
                                                        <div style={{ fontSize: "24px" }}>
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalLSDBAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}
                                                        </div>
                                                        <div>
                                                            (
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalOnPlatformLSDBAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}{" "}
                                                            on platform,&nbsp;
                                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                                totalOffPlatformLSDBAUsed ?? 0,
                                                                CurrencyCode.GBP,
                                                                true,
                                                                2
                                                            )}{" "}
                                                            off platform)
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-12 col-sm-fluid col-left ml-15 mb-20">
                                        <button
                                            className="hyperlink"
                                            onClick={() =>
                                                Navigator.navigateTo(Urls.get().UpdateLifetimeAllowanceDetail, {
                                                    scrollAfterNavigating: true,
                                                    queryParamsObject: {
                                                        hierarchyid: props.accountHierarchyId,
                                                    },
                                                })
                                            }
                                        >
                                            Update Allowance Details
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-fluid col-equalise">
                                    <table className="table-subtle row-higher table-first-last-cell-padding-reset has-first-cell-highlighted">
                                        <tbody>
                                            <tr>
                                                <th>PCLS paid to date</th>
                                                <td>
                                                    {MoneyDisplayHelper.FromatMoneyDisplay(
                                                        lifetimeAllowanceData?.PclsToDate,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Total UFPLS paid to date</th>
                                                <td>
                                                    {MoneyDisplayHelper.FromatMoneyDisplay(
                                                        lifetimeAllowanceData?.UfplsToDate,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    Protection details
                                                    <Permission
                                                        userClaim={[
                                                            UserClaim.AdviserPortalCustomerFullyAccessReadWrite,
                                                            UserClaim.AdviserPortalCustomerPartialAccessReadWrite,
                                                            UserClaim.AdviserPortalDluSippDetailCanView
                                                        ]}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="edit-circle-icon-button label-sr-only ml-5"
                                                            title="Edit"
                                                            onClick={() => {
                                                                setShowEditLightbox(true);
                                                            }}
                                                        >
                                                            <span className="icon" aria-hidden="true"></span>
                                                            <span className="text">Edit protection details</span>
                                                        </button>
                                                    </Permission>
                                                    {showEditLightbox && (
                                                        <Lightbox
                                                            cssWrapper="is-default-lightbox"
                                                            show={showEditLightbox}
                                                            onClose={() => setShowEditLightbox(false)}
                                                            title="Update Pension Protection Details"
                                                        >
                                                            <PensionProtection
                                                                hideHeading={true}
                                                                hideContainerClasses={true}
                                                                id={getCustomerId()} //customer id
                                                                hasReadWriteAccess={true}
                                                                onSaveBack={(result) => {
                                                                    setHasPensionProtection(result?.HasAnyProtection)
                                                                }}
                                                                callback={() => {
                                                                    setShowEditLightbox(false);
                                                                }}
                                                                disabled={!checkPermission([
                                                                    UserClaim.AdviserPortalCustomerFullyAccessReadWrite,
                                                                    UserClaim.AdviserPortalCustomerPartialAccessReadWrite
                                                                ])}
                                                            />
                                                        </Lightbox>
                                                    )}
                                                </th>
                                                <td>
                                                    {formatPensionProtection(
                                                        hasPensionProtection
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <div className="d-flex f-direction-column">
                    <div className="row mb-5">
                        <div className="col-auto col-middle">
                            <h2 className="mb-22">Regular drawdown details</h2>
                        </div>
                        <div className="col-fluid">
                            {checkPermission(UserClaim.AdviserPortalTPBAndEditIncomeDrawdownReadWrite) && (
                                <a
                                    type="button"
                                    title="Edit"
                                    className="edit-circle-icon-button ml-5 label-sr-only"
                                    href={getEditRegularDrawdownHref()}
                                    onClick={(e) => {
                                        if (isDpcNprAccount()) {
                                            e.preventDefault();
                                            setShowRestrictionLightbox(true);
                                            setRestrictionLightboxErrorMessage("This plan includes disqualifying pension credit. Unfortunately, instructions cannot be completed online. Please contact us on 0345 279 1001.");
                                        }
                                    }}
                                >
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text">Edit regular drawdown</span>
                                </a>
                            )}
                        </div>
                    </div>                    
                    <h3 className="mb-5">Active tailored drawdown instructions</h3>                    
                    <div className="panel-subtle mb-40">
                        {regularCrystallisationData?.length > 0 ? (
                            <>
                                <Table
                                    cssWrapper="table-subtle table-first-last-cell-padding-reset mb-20"
                                    data={regularCrystallisationData}
                                    col={[
                                        {
                                            title: "Drawdown Amount",
                                            key: "CrystallisationAmount",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Frequency",
                                            key: "Frequency",
                                            render: (data) => {
                                                return FrequencyMap[data];
                                            },
                                        },
                                        {
                                            title: "Next Payment Date",
                                            key: "PaymentDate",
                                            render: (data) => {
                                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                                            },
                                        },
                                        {
                                            title: "PCLS",
                                            key: "PclsAmount",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Taxable Income",
                                            key: "TaxableIncome",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Disinvestment",
                                            key: "DisinvestmentStrategy",
                                            render: (data) => {
                                                return DisinvestmentStrategyMap[data];
                                            },
                                        },
                                    ]}
                                />
                                {
                                    (WizardLinkRestriction(props.headaccount, props.subAccountHierarchyId, ProcessType.CancelRegularCrystallisation) || SubAccountWizardLinkRestriction(RestrictionReasonStore.getData(), ProcessType.CancelRegularCrystallisation)) 
                                    ? 
                                    <div>
                                        <button
                                            className="hyperlink"
                                            onClick={() =>
                                                {
                                                    setShowRestrictionLightbox(true);
                                                    setRestrictionLightboxErrorMessage(isPensionProcessRestriction(RestrictionReasonStore.getData())
                                                    ? "You cannot process this action until pension event is authorised"
                                                    : "You cannot process this action until the account is active");
                                                }
                                            }
                                        >
                                            Cancel tailored drawdown
                                        </button> 
                                    </div>
                                    :
                                    <div>
                                        {checkPermission(UserClaim.AdviserPortalCancelRegularCrystalisationReadWrite) &&
                                        checkPaymentDateDifference() && (
                                            <button
                                                className="hyperlink"
                                                onClick={() =>
                                                    Navigator.navigateTo(Urls.get().CancelRegularCrystallisationReview, {
                                                        scrollAfterNavigating: true,
                                                        queryParamsObject: {
                                                            hierarchyid: props.accountHierarchyId,
                                                            subAccountHierarchyId: props.subAccountHierarchyId,
                                                            clAccountId: props.headaccount.HeadClAccountId,
                                                        },
                                                    })
                                                }
                                            >
                                                Cancel tailored drawdown
                                            </button>
                                        )}
                                    </div>
                                }
                            </>
                        ) : (
                            <div>
                                <span>No regular drawdown(s) set up for this client</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="d-flex f-direction-column">                    
                    <h3 className="mb-5">Drawdown history</h3>                    
                    <div className="panel-subtle mb-0">
                        {historicCrystallisationData?.length > 0 ? (
                            <>
                                <div className="col-12 col-lg-6">
                                    <DateRange
                                        minDate={JsonDateParser.toDate(props.headaccount.InceptionDate ?? historicCrystallisationData[0].PaymentDate)}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        cssGridDate="col-12 col-sm-auto"
                                        cssGridTo="col-fluid col-max-180"
                                        cssGridFrom="col-fluid col-max-180"
                                        cssGridLabel="col-12 col-sm-auto col-middle"
                                        selectValue={dateSelected}
                                        onChange={(
                                            fromDate: Date,
                                            toDate: Date,
                                            fromInception: boolean,
                                            dateSelected: string
                                        ) => {
                                            addEvent({
                                                event: "productOverviewCrystallisationTab_interaction",
                                                eventParameters: {
                                                    eventAction: "date range selector",
                                                    eventCategory: eventCategoryForGTM.productOverviewCrystallisationTab,
                                                    eventLabel: CommonHelper.getOptionsTxt(
                                                        dateSelected,
                                                        DateOptions
                                                    ).toLowerCase(),
                                                },
                                            });
                                            setFromDate(fromDate);
                                            setToDate(toDate);
                                            setDateSelected(dateSelected);
                                        }}
                                    />
                                    <button
                                        className="btn secondary mt-5"
                                        onClick={() => filteredHistoricCrystallisationDataByDateRange(historicCrystallisationData, fromDate, toDate)}
                                    >
                                        Search
                                    </button>
                                </div>
                                <Table
                                    cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                    data={filteredHistoricCrystallisationData}
                                    col={[
                                        {
                                            title: "Drawdown amount",
                                            key: "TotalAmount",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Tax-Free Cash",
                                            key: "TaxFreeCash",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "Type",
                                            key: "DrawdownType",
                                            render: (data) => {
                                                return DrawdownTypeOptionsMap[data];
                                            },
                                        },
                                        {
                                            title: "Excess Benefits",
                                            key: "ExcessBenefits",
                                        },
                                        {
                                            title: "Amount of LSA",
                                            key: "AmountOfLSA",
                                            render: (data) => {
                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                    data,
                                                    CurrencyCode.GBP,
                                                    true,
                                                    2
                                                );
                                            },
                                        },
                                        {
                                            title: "ID",
                                            key: "Id",
                                        },
                                        {
                                            title: "Payment date",
                                            key: "PaymentDate",
                                            render: (data) => {
                                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                                            },
                                        },
                                        {
                                            title: "Protection",
                                            key: "Protection",
                                            render: (data) => {
                                                return formatPensionProtection(data);
                                            },
                                        },
                                    ]}
                                    TotalBody={[
                                        {
                                            data: MoneyDisplayHelper.FromatMoneyDisplay(
                                                filteredHistoricCrystallisationData
                                                    ? filteredHistoricCrystallisationData.reduce((sum, crystallisation) => (sum += crystallisation.TotalAmount || 0), 0)
                                                    : 0,
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            )
                                        },
                                        {
                                            data: MoneyDisplayHelper.FromatMoneyDisplay(
                                                filteredHistoricCrystallisationData
                                                    ? filteredHistoricCrystallisationData.reduce((sum, crystallisation) => (sum += crystallisation.TaxFreeCash || 0), 0)
                                                    : 0,
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            ),
                                            colSpan: 8
                                        }
                                    ]}
                                    DisplayTotalText = {true}
                                    TotalTextcolSpan = {9}
                                />
                            </>
                        ) : (
                            <div>
                                <span>No historical drawdown(s) for this client</span>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: totalRows / pageSize,
                            TotalRecords: totalRows,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            setPageSize(recordsPerPage);
                            setCurrentPage(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
            </div>
        </>
    );
};
